import { loanOfficersManagementApi, userObsoleteApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE = createNamedActions('loanOfficersManagement', {
  GET_LOAN_OFFICER_USERS: 'GET_LOAN_OFFICER_USERS',
  GET_LOAN_OFFICER_MANAGER_USERS: 'GET_LOAN_OFFICER_MANAGER_USERS',

  GET_RELATIONS_BETWEEN_LO_AND_LOM: 'GET_RELATIONS_BETWEEN_LO_AND_LOM',
  ADD_RELATIONS_BETWEEN_LO_AND_LOM: 'ADD_RELATIONS_BETWEEN_LO_AND_LOM',
  DELETE_RELATIONS_BETWEEN_LO_AND_LOM: 'DELETE_RELATIONS_BETWEEN_LO_AND_LOM',
});

const loanOfficerUserSchema = new schema.Entity('loanOfficerUsers');
const loanOfficerManagerUserSchema = new schema.Entity('loanOfficerManagerUsers');
const relationSchema = new schema.Entity('relations', {}, { idAttribute: 'dependentId' });

export const getLoanOfficerUsersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await userObsoleteApi.getUserByRole(params);

  return dispatch({
    type: LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE.GET_LOAN_OFFICER_USERS,
    payload: normalize(data, [loanOfficerUserSchema]),
  });
});

export const getLoanOfficerManagerUsersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await userObsoleteApi.getUserByRole(params);

  return dispatch({
    type: LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE.GET_LOAN_OFFICER_MANAGER_USERS,
    payload: normalize(data, [loanOfficerManagerUserSchema]),
  });
});

export const getRelationsBetweenLOAndLOMAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanOfficersManagementApi.getLoanManagement(params);

  return dispatch({
    type: LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE.GET_RELATIONS_BETWEEN_LO_AND_LOM,
    payload: normalize(data, [relationSchema]),
  });
});

const addRelationsBetweenLOAndLOMAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanOfficersManagementApi.createLoanManagement(params);

  return dispatch({
    type: LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE.ADD_RELATIONS_BETWEEN_LO_AND_LOM,
    payload: data,
  });
});

export const deleteRelationsBetweenLOAndLOMAction = catchAsyncActionError(
  params => async dispatch => {
    await loanOfficersManagementApi.deleteLoanManagement(params);

    return dispatch({
      type: LOAN_OFFICERS_MANAGEMENT_ACTION_TYPE.DELETE_RELATIONS_BETWEEN_LO_AND_LOM,
      payload: params,
    });
  },
);

export const updateRelationsBetweenLOAndLOMAction =
  ({ oldOwnerId, newOwnerId, dependentId }) =>
  async dispatch => {
    if (oldOwnerId) {
      await dispatch(deleteRelationsBetweenLOAndLOMAction({ ownerId: oldOwnerId, dependentId }));
    }

    await dispatch(addRelationsBetweenLOAndLOMAction({ ownerId: newOwnerId, dependentId }));
  };
